import { TextAreaFieldCombinedProps } from './types';

const usePresenter = (props: TextAreaFieldCombinedProps): TextAreaFieldCombinedProps => {
  return props;
};

export default usePresenter;
